import { Field, FormikProps } from "formik";
import * as React from "react";
import bootstrapStyles from "../../css/bootstrap.module.css";
import { FormValues } from "../../support/FormValues";
import { FieldCustomMask } from "../../components/FieldCustomMask";
import FieldSelect from "../../components/FieldSelect";
import { AccountTypeEnum } from "../../support/AccountTypeEnum";
import { FieldNameEnum } from "../../support/FieldNameEnum";

interface RothProps {
  formikBag: FormikProps<FormValues>;
}
const RothToAccountTypeOptions = [AccountTypeEnum.RothIRA];
export default RothToAccountTypeOptions;

export const Roth = ({ formikBag: { values } }: RothProps) => {
  return (
    <React.Fragment>
      <div className={bootstrapStyles.row}>
        <div className={bootstrapStyles["col-md-6"]}>
          <Field
            type="text"
            spellCheck="false"
            name={FieldNameEnum.rothYear}
            label="What year did you first fund your Roth IRA?"
            mask="year"
            component={FieldCustomMask}
            style={{ width: "110px" }}
          />
        </div>
      </div>
      <div className={bootstrapStyles.row}>
        <div className={bootstrapStyles["col-md-12"]}>
          <hr />
        </div>
      </div>
      <div className={bootstrapStyles.row}>
        <div className={bootstrapStyles["col-md-6"]}>
          <Field
            name={FieldNameEnum.toAccountType}
            label="Transfer Account To"
            options={RothToAccountTypeOptions}
            component={FieldSelect}
            removeDefaultSelectOption
          />
        </div>
      </div>
    </React.Fragment>
  );
};
